import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { CourseService } from 'src/app/services/course.service';
import { UsersService } from 'src/app/services/users.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-course-details',
  templateUrl: './course-details.component.html',
  styleUrls: ['./course-details.component.scss']
})
export class CourseDetailsComponent implements OnInit {

  @ViewChild('courses', { read: ElementRef }) public courses: ElementRef<any>;

  public selectedTopic: any = 'Hematology';
  public courseDetails: any = {};
  public selectedModuleId: any;
  public selectedLessonId: any;
  public selectedLesson: any = {};
  public modules: any[] = [];
  public lessons: any[] = [];
  public courseId: any;
  public isInCart: boolean = false;
  public isPurchased = false;
  public previewLesson: any;
  public apiURL: any = environment.apiURL;
  public relatedCourses: any[] = [];
  public courseRequirements: any[] = [];
  public subscriptionDetails: any;
  public toWhom: any[] = [];
  public toLearn: any[] = [];
  public userId;
  public categories: any[] = ['Clinical Chemistry', 'Clinical Pathology', 'Hematology', 'Immunoassay', 'Quality Assurance', 'Samples & Pre-Analytics', 'Micro-Biology', 'General', 'Transfusion Medicine'];
  enrollNowLoading: boolean = false;
  constructor(private toastrService: ToastrService, private router: Router, private courseService: CourseService, private sanitizer: DomSanitizer, public authService: AuthService, public userService: UsersService) {
  }
  ngOnInit(): void {
    this.userId = JSON.parse(sessionStorage.getItem("logged-in-user"))?._id;
    this.isPurchased = false;
    this.courseId = this.router.url.split('/')[3];
    this.getCourseDetails();
    this.getAllModules();
    if (this.userId)
      this.getUserDetails();
    if (JSON.parse(sessionStorage.getItem('logged-in-user'))) {
      this.courseInCart();
      this.getAllPurchasedCourses();
    }

  }

  public getUserDetails() {
    this.userService.getUserDetails(this.userId).subscribe((value: any) => {
      this.subscriptionDetails = value.subscription;
    })
  }

  public scrollRight(): void {
    if (window.innerWidth > 600)
      this.courses.nativeElement.scrollTo({ left: (this.courses.nativeElement.scrollLeft + 350), behavior: 'smooth' });
    else
      this.courses.nativeElement.scrollTo({ left: (this.courses.nativeElement.scrollLeft + 311), behavior: 'smooth' });
  }

  public scrollLeft(): void {
    if (window.innerWidth > 600)
      this.courses.nativeElement.scrollTo({ left: (this.courses.nativeElement.scrollLeft - 350), behavior: 'smooth' });
    else
      this.courses.nativeElement.scrollTo({ left: (this.courses.nativeElement.scrollLeft - 311), behavior: 'smooth' });

  }

  onClickBack() {
    window.history.back();
  }

  onSelectTopic(topic) {
    this.selectedTopic = topic;
  }

  getCourseDetails() {
    this.courseService.getCourse(this.courseId).subscribe(
      (res: any) => {
        this.courseDetails = res;
        this.courseRequirements = res.course.prerequisite.split('.');
        this.courseRequirements.pop();
        this.toWhom = res.course.toWhom.split('.');
        this.toWhom.pop();
        this.toLearn = res.course.toLearn.split('.');
        this.toLearn.pop();
        let body = {
          category: res.course.category,
          searchText: ''
        }
        this.courseService.getAllPublishedCourses(body).subscribe(
          (res: any) => {
            for (let i = 0; i < res.length; i++) {
              if (res._id! == this.courseId) {
                this.relatedCourses.push(res[i]);
              }
            }
          }
        )

      }
    )
  }

  getAllPurchasedCourses() {
    this.courseService.getAllPurchasedCourse().subscribe(
      (res: any) => {
        for (let i = 0; i < res.length; i++) {
          if (res[i].courseId['_id'] == this.courseId) {
            this.isPurchased = true;
            break;
          }
        }
      }
    )
  }

  isProMember() {
    return this.subscriptionDetails?.subscriptionType === 'PRO' && this.subscriptionDetails?.subscriptionStatus === 'Approved';
  }

  getVideo(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  getAllModules() {
    this.courseService.getAllModules(this.courseId).subscribe(
      (res: any) => {
        this.modules = res;
        for (let i = 0; i < this.modules.length; i++) {
          this.onClickModule(this.modules[i]);
          if (this.previewLesson) {
            break;
          }
        }
      }
    )
  }

  onClickKnowMore(course) {
    this.router.navigate(['courses/details/' + course._id]);
  }

  onClickModule(module) {
    this.selectedModuleId = module._id;
    this.courseService.getAllLessons(this.courseId, this.selectedModuleId).subscribe(
      (res: any) => {
        this.lessons = res;
        for (let i = 0; i < this.lessons.length; i++) {
          if (this.lessons[i].isPreview) {
            this.previewLesson = { ...this.lessons[i] };
            this.previewLesson['moduleId'] = module._id;
            break;
          }
        }
      }
    )
  }

  onClickLesson(lesson) {
    this.selectedLessonId = lesson._id;
    this.courseService.getLesson(this.courseId, this.selectedModuleId, this.selectedLessonId).subscribe(
      (res: any) => {
        this.selectedLesson = res;
      }
    )
  }

  onClickBuyNow() {
    if (!this.authService.loggedIn) {
      this.router.navigate(['login']);
    }
    else {
      this.router.navigate(['pricing']);
    }
  }

  isSampleCourse() {
    return this.courseDetails?.course?.price == 0;
  }

  onClickEnrollNow() {
    this.enrollNowLoading = true;
    this.courseService.purchaseCourse(this.courseId, { category: this.courseDetails.category }).subscribe(
      (res: any) => {
        this.isPurchased = true;
        this.getCourseDetails();
        this.courseDetails.course.purchasedCourseId = res?.id;
        this.toastrService.success('Course enrolled successfully.');
        this.enrollNowLoading = true;
        if (this.isSampleCourse()) {
          this.onClickPlay();
        }
      }, (error) => {
        this.toastrService.error(error.error.message);
        this.enrollNowLoading = true;
      }
    )
  }

  onClickPlay() {
    if (!this.isSampleCourse()) {
      sessionStorage.setItem('purchasedCourseId', JSON.stringify(this.courseDetails.course.purchasedCourseId));
      this.router.navigate(['courses/play/' + this.courseId]);
    }
    else {
      this.router.navigate(['sample-courses/play/' + this.courseId]);
    }
  }

  courseInCart() {
    this.courseService.getCartedCourses().subscribe(
      (res: any) => {
        for (let i = 0; i < res.length; i++) {
          if (res[i]._id == this.courseId) {
            this.isInCart = true;
            break;
          }
        }
      }
    )
  }

  onClickAddToCart() {
    if (!this.authService.loggedIn) {
      this.router.navigate(['login']);
    }
    else {
      this.courseService.addToCart(this.courseId).subscribe(
        (res) => {
          this.toastrService.success('Course added to cart!')
          this.courseInCart();
        }
      )
    }
  }

  onClickGoToCart() {
    this.router.navigate([this.courseId + '/cart']);
  }

  onGetPreviewLesson() {

  }
}
